<template>
  <div class="app-container program-page">
    <myTableSearch
      ref="tableRef"
      :formData="formData"
      :tableLabel="tableLabel"
      :queryFn="queryFn"
      :queryParams="queryParams"
      :searchColLg="6"
      :isTool="false"
      labelNameWidth="90px"
      dataRow="rows"
    >
      <template slot="ifRealNameAuth" slot-scope="scope">
        <el-tag v-if="scope.row.ifRealNameAuth === '1' || scope.row.ifRealNameAuth === 1" type="success" size="small">是</el-tag>
        <el-tag v-else type="warning" size="small" effect="plain">否</el-tag>
      </template>
      <template slot="createTime" slot-scope="scope">
        <span>{{ parseTime(scope.row.createTime) || '-' }}</span>
      </template>
    </myTableSearch>
  </div>
</template>

<script>
import { getProgramUserInfo } from '@/api/sys/program'

export default {
  name: 'ProgramUser',
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50]
      },
      formData: [
        {
          label: '手机号',
          type: 'numberInput',
          key: 'phone',
          colLg: 6,
          placeholder: '手机号',
          maxlength: 11
        },
        {
          label: '姓名',
          type: 'input',
          key: 'name',
          colLg: 6,
          placeholder: '姓名'
        },
        {
          label: '身份证号',
          type: 'input',
          key: 'idCardNo',
          colLg: 6,
          placeholder: '身份证号',
          maxlength: 18
        }
      ],
      tableLabel: [
        {
          prop: 'phone',
          label: '手机号',
          minWidth: 140,
          align: 'center'
        },
        {
          prop: 'name',
          label: '姓名',
          minWidth: 120,
          align: 'center'
        },
        {
          prop: 'ifRealNameAuth',
          label: '是否实名',
          width: 100,
          align: 'center'
        },
        {
          prop: 'idCardNo',
          label: '身份证号',
          minWidth: 200,
          align: 'center'
        },
        {
          prop: 'createTime',
          label: '注册时间',
          width: 180,
          align: 'center'
        }
      ]
    }
  },
  methods: {
    queryFn(queryParams) {
      return getProgramUserInfo(queryParams)
    }
  }
}
</script>

<style scoped lang="scss">
.program-page {
  height: 100%;
  padding: 16px;
  box-sizing: border-box;
  background: #f5f7fa;

  /deep/.myTableSearch {
    padding: 20px 24px 16px;
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

    .search {
      margin-bottom: 0;
      padding-bottom: 12px;
      border-bottom: 1px solid #ebeef5;
    }

    .line {
      display: none;
    }

    .tableTool {
      display: none;
    }

    .el-table {
      margin-top: 0;
    }

    .el-table th {
      background: #f5f7fa !important;
      color: #303133;
      font-weight: 500;
    }

    .el-pagination {
      margin-top: 16px;
      text-align: right;
    }
  }
}
</style>
